import { Field, useFormikContext } from "formik";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import DeleteIcon from "../../assets/icons/delete-icon";
import { url } from "../../redux/config";
import "../forms/form.css";
import SearchAddFeild from "../forms/search-add-field";
import errorToast from "../helper-components/error-toast";
import { api } from "../../redux/apis/api";
import {
  salesProductDetailsAction,
  salesProductListAction,
} from "../../redux/actions/sales-action";
import SelectField from "../forms/select-field";
import AddButton from "../buttons/button";
import LoadingOverlay from "../helper-components/overlay-loading";

const SalesItemsSection = ({
  isClone = false,
  auto,
  clickedplus,
  initialData,
  disabled = false,
  addBatchFn = () => {},
  searchRef,
  qtyDis = false,
  standAlone = false,
  prefixName,
  heading = [],
  isNotViewOnly = true,
}) => {
  const inputRefs = useRef(null);
  const [loading, setLoading] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  console.log(values, "dgdfgdfgdfgdfgfdgdfg");

  const dispatch = useDispatch();
  const [localData, setLocalData] = useState([]);

  // ✅ ADDED: run clone validation only once per clone/click session
  const ranCloneValidationRef = useRef(false);

  const fetchData = async (inputValue, callback, field) => {
    const onSuccess = (data) => {
      const options =
        data?.data === null
          ? []
          : data.data
              .map((item) => ({
                value: item.item_id,
                label: item[field],
              }))
              .filter(
                (option) =>
                  !values?.data?.some((item) => item?.item_id === option.value)
              );
      setLocalData(data.data);
      callback(options);
    };
    const onError = (data) => {};
    if (inputValue?.length > 0) {
      dispatch(
        salesProductListAction(
          {
            field: field,
            value: inputValue,
          },
          onSuccess,
          onError
        )
      );
    }
  };

  const removeRow = (rowIndex) => {
    const updatedData = [...values.data];
    updatedData.splice(rowIndex, 1);
    setFieldValue("data", updatedData);

    const raw_total_amount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_total_amount) || 0);
    }, 0);

    const total_tax = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_tax_amount) || 0);
    }, 0);

    const total_discount = updatedData.reduce((sum, item) => {
      return sum + (parseFloat(item.item_discount_amount) || 0);
    }, 0);

    // Subtotal = Total - Tax - Discount
    const sub_total = (raw_total_amount - total_tax + total_discount).toFixed(
      2
    );

    const total_amount = Math.round(raw_total_amount).toFixed(2);
    const round_off_value = (
      Math.round(raw_total_amount) - raw_total_amount
    ).toFixed(2);

    console.log(
      sub_total,
      total_tax,
      total_discount,
      total_amount,
      round_off_value,
      "dfgdgdfgdfgdfgd"
    );

    // Set all values to form
    setFieldValue(`${prefixName}_sub_total`, sub_total);
    setFieldValue(`${prefixName}_total_gst`, total_tax.toFixed(2));
    setFieldValue(`${prefixName}_total_discount`, total_discount.toFixed(2));
    setFieldValue(`${prefixName}_total_amount`, total_amount);
    setFieldValue(`${prefixName}_round_off_value`, round_off_value);
    setFieldValue(`${prefixName}_tcs_or_tds_amount`, 0);
    setFieldValue(`${prefixName}_tcs_or_tds_percentage_id`, "");
    setFieldValue(`${prefixName}_tcs_or_tds_percentage`, 0);
    setFieldValue(`${prefixName}_tds_tcs_type`, "");
    setFieldValue(`${prefixName}_is_invoice_dis_percentage`, true);
    setFieldValue(`${prefixName}_invoice_discount`, "");

    setFieldValue(`${prefixName}_invoice_discount_percentage`, "");
    setFieldValue(`header_inv_dis_per`, "");
  };

  //ON QUANTITY CHANGE
  const handleQuantityChange = async (
    event,
    rowIndex,
    base_quantity,
    item_uom_id,
    item_uom
  ) => {
    const updatedData = values.data.map((row, index) =>
      index === rowIndex
        ? { ...row, quantity: parseFloat(event.target.value) }
        : row
    );
    setFieldValue("data", updatedData);

    const item = values.data[rowIndex];
    const stockApiUrl = `${url}/v1/inventory/stock/sales/items?item_id=${
      item.item_id
    }&item_quantity=${event.target.value}&base_quantity=${parseInt(
      base_quantity
    )}&cmr_id=${values?.cmr_id}`;

    if (parseFloat(event?.target?.value) > 0) {
      try {
        setLoading(true);
        const stockApiResponse = await api.get(stockApiUrl);
        if (
          stockApiResponse?.data?.code === 200 &&
          stockApiResponse?.data?.data?.itemDetails?.length > 0
        ) {
          const itemDetail = stockApiResponse?.data?.data?.itemDetails;
          const itemBatchList = stockApiResponse?.data?.data?.itemBatchList;
          const item_discount_amount = itemDetail.reduce((acc, batch) => {
            return acc + parseFloat(batch.item_discount_amount || 0);
          }, 0);
          const item_tax_amount = itemDetail.reduce((acc, batch) => {

            return acc + parseFloat(batch.item_tax_amount || 0);
          }, 0);
          const item_total_amount = itemDetail.reduce((acc, batch) => {
            return (
              acc +
              parseFloat(batch.item_selling_price || 0) *
                parseFloat(batch.quantity || 0) -
              parseFloat(batch.item_discount_amount || 0) +
              parseFloat(batch.item_tax_amount || 0)
            );
          }, 0);

          console.log(itemDetail, "fggdfgdfgdgdfgdfgdfgfdgdg");

          const updatedDataRow = {
            ...updatedData[rowIndex],
            item_discount_amount: item_discount_amount,
            item_tax_amount: item_tax_amount,
            item_total_tax_percentage:
              itemDetail?.[0]?.item_total_tax_percentage,
            item_batches:
              itemDetail?.map((batch) => ({
                item_batch_number: batch?.batchNumber,
                item_batch_sales_rate: batch?.item_selling_price
                  ? parseFloat(batch?.item_selling_price)
                  : 0,
                item_batch_quantity: batch?.quantity
                  ? parseInt(batch?.quantity)
                  : 0,
                item_batch_free_quantity: batch?.item_batch_free_quantity
                  ? parseInt(batch?.item_batch_free_quantity)
                  : 0,

                item_batch_total_base_sales_rate:
                  parseFloat(batch?.item_selling_price || 0) *

                  parseInt(batch?.quantity || 0),
                item_batch_discount_percentage: batch?.item_discount_percentage
                  ? parseFloat(batch?.item_discount_percentage)
                  : 0,
                item_batch_discount_amount: batch?.item_discount_amount
                  ? parseFloat(batch?.item_discount_amount)
                  : 0,

                item_batch_discounted_sales_rate:
                  (
                    parseFloat(batch?.item_selling_price || 0) *
                      parseInt(batch?.quantity) -
                    parseFloat(batch?.item_discount_amount || 0)
                  ).toFixed(2) || 0,

                item_batch_tax_percentage: batch?.item_total_tax_percentage
                  ? parseFloat(batch?.item_total_tax_percentage)
                  : 0,
                item_batch_tax_amount: batch?.item_tax_amount
                  ? parseFloat(batch?.item_tax_amount)
                  : 0,
                item_batch_final_sales_rate: (
                  (parseFloat(batch?.item_selling_price) *
                    parseFloat(batch?.quantity) -
                    parseFloat(batch?.item_discount_amount) +
                    parseFloat(batch?.item_tax_amount)) /
                  parseFloat(batch?.quantity)
                ).toFixed(2),
                item_batch_unit_price: batch?.item_unit_price
                  ? parseFloat(batch?.item_unit_price)
                  : 0,
                item_batch_total_sales_rate: (
                  parseFloat(batch?.item_selling_price) *
                    parseFloat(batch?.quantity) -
                  parseFloat(batch?.item_discount_amount) +
                  parseFloat(batch?.item_tax_amount)
                ).toFixed(2),
                item_exp_date: batch?.expiryDate,
                from_bin_location: batch?.item_rack_location,

                from_bin_id: batch?.to_bin_id,
                item_id: item.item_id,
                item_batch_avail_quantity: parseInt(batch?.quantity) ?? 0,
              })) ?? [],
            item_uom_id: item_uom_id,
            item_uom: item_uom,
            base_quantity: base_quantity,
            item_gst: itemDetail?.[0]?.item_total_tax_percentage,
            item_sgst: item_tax_amount / 2,
            item_cgst: item_tax_amount / 2,
            item_igst: 0,
            item_total_amount: item_total_amount?.toFixed(2),
            itemBatchList: itemBatchList ?? [],
            instock: true,
          };

          updatedData[rowIndex] = updatedDataRow;
          setFieldValue("data", [...updatedData]);

          const raw_total_amount = updatedData.reduce((sum, item) => {
            return sum + (parseFloat(item.item_total_amount) || 0);
          }, 0);

          const total_tax = updatedData.reduce((sum, item) => {
            return sum + (parseFloat(item.item_tax_amount) || 0);
          }, 0);

          const total_discount = updatedData.reduce((sum, item) => {
            return sum + (parseFloat(item.item_discount_amount) || 0);

          }, 0);

          // Subtotal = Total - Tax - Discount
          const sub_total = (
            raw_total_amount -
            total_tax +
            total_discount
          ).toFixed(2);

          const total_amount = Math.round(raw_total_amount).toFixed(2);
          const round_off_value = (
            Math.round(raw_total_amount) - raw_total_amount
          ).toFixed(2);

          console.log(
            sub_total,
            total_tax,
            total_discount,
            total_amount,
            round_off_value,
            "dfgdgdfgdfgdfgd"
          );

          // Set all values to form
          setFieldValue(`${prefixName}_sub_total`, sub_total);
          setFieldValue(`${prefixName}_total_gst`, total_tax.toFixed(2));
          setFieldValue(
            `${prefixName}_total_discount`,
            total_discount.toFixed(2)
          );
          setFieldValue(`${prefixName}_total_amount`, total_amount);
          setFieldValue(`${prefixName}_round_off_value`, round_off_value);
          setFieldValue(`${prefixName}_tcs_or_tds_amount`, 0);
          setFieldValue(`${prefixName}_tcs_or_tds_percentage_id`, "");
          setFieldValue(`${prefixName}_tcs_or_tds_percentage`, 0);
          setFieldValue(`${prefixName}_tds_tcs_type`, "");
          setFieldValue(`${prefixName}_is_invoice_dis_percentage`, true);
          setFieldValue(`${prefixName}_invoice_discount`, "");
          setFieldValue(`${prefixName}_invoice_discount_percentage`, "");

          setFieldValue(`header_inv_dis_per`, "");

          setLoading(false);
        } else {
          const updatedDataWithInstock = updatedData.map((row, index) =>
            index === rowIndex
              ? {
                  ...row,
                  item_discount_amount: 0,
                  item_tax_amount: 0,
                  item_discount_percentage: 0,
                  item_gst: 0,
                  item_sgst: 0,
                  item_cgst: 0,
                  item_igst: 0,
                  item_total_amount: 0,
                  item_total_tax_percentage: 0,
                  item_batches: [],
                  item_uom_id: item_uom_id,
                  item_uom: item_uom,
                  base_quantity: base_quantity,
                }
              : row
          );
          setFieldValue("data", updatedDataWithInstock);
          setLoading(false);
          errorToast(
            `Product ${item.item_name} with quantity ${event.target.value} is not available`
          );
        }
      } catch (error) {
        setLoading(false);

        const updatedDataWithError = updatedData.map((row, index) =>
          index === rowIndex
            ? {
                ...row,
                item_discount_amount: 0,
                item_tax_amount: 0,
                item_discount_percentage: 0,
                item_gst: 0,
                item_sgst: 0,
                item_cgst: 0,
                item_igst: 0,
                item_total_amount: 0,
                item_total_tax_percentage: 0,
                item_batches: [],
                item_uom_id: item_uom_id,
                item_uom: item_uom,
                base_quantity: base_quantity,
              }
            : row
        );
        setFieldValue("data", updatedDataWithError);
        errorToast(
          `${item.item_name} available quantity is ${parseInt(
            error?.response?.data?.data?.itemDetails?.item_sellable_quantity ??
              0
          )}`
        );
      }
    } else {

      const updatedData = values.data.map((row, index) =>
        index === rowIndex
          ? {
              ...row,
              item_discount_amount: 0,
              item_tax_amount: 0,
              item_discount_percentage: 0,
              item_gst: 0,
              item_sgst: 0,
              item_cgst: 0,
              item_igst: 0,
              item_total_amount: 0,
              item_total_tax_percentage: 0,
              item_batches: [],
              item_uom_id: item_uom_id,
              
              item_uom: item_uom,
              base_quantity: base_quantity,
            }
          : row
      );
      setFieldValue("data", updatedData);
    }
  };

  const hasDuplicateItemId = (itemId, currentIndex) => {
    const itemIdsExceptCurrent = values.data
      .filter((_, index) => index !== currentIndex)
      .map((item) => item.item_id);

    return itemIdsExceptCurrent.includes(itemId);
  };

  const onSuccessDetails = (data, rowIndex, filteredData) => {
    const oldData = [...values?.data];
    oldData.pop();
    const updatedData = {
      ...filteredData,
      uom_dropdown: data?.data?.uom_dropdown
        ? data?.data?.uom_dropdown.map((uom) => ({
            item_uom_id: uom?.item_id,
            label: uom?.alt_uom,
            value: uom?.alt_uom,
            base_quantity: uom?.base_quantity,
          }))
        : [],
      base_quantity: data?.data?.uom_dropdown?.find(
        (uom) => uom?.item_id === filteredData?.item_uom_id
      )?.base_quantity,
    };

    setFieldValue("data", [...oldData, updatedData, initialData]);
    inputRefs.current?.focus();
  };
  const onErrorDetails = (data) => {
    errorToast(data?.data?.message);
  };

  console.log(values, "dfgdgdfgdfgdfgd");

  // Auto logic - separate from clone
  useEffect(() => {
    if (auto) {
      console.log(values.data, "values.data");
      values?.data?.forEach((item, index) => {
        if (
          item.item_to_be_delivered &&
          item.item_to_be_delivered > 0 &&
          index < values.data.length - 1
        ) {
          console.log(item.item_to_be_delivered, "item.item_to_be_delivered");
          const event = {
            target: {
              value: item.item_to_be_delivered,
            },
          };
          handleQuantityChange(
            event,
            index,
            item.base_quantity,
            item.item_uom_id,
            item.item_uom
          );
        }
      });
    }
  }, [values?.data?.length, auto]);

  // ✅ ADDED: reset clone-run flag when clone/click flags go false
  useEffect(() => {
    if (!isClone && !clickedplus) {
      ranCloneValidationRef.current = false;
    }
  }, [isClone, clickedplus]);

  // ✅ UPDATED: Clone validation logic - run only on clone/click (not on every data length change)
  useEffect(() => {
    if (!isNotViewOnly) return;
    if (!(isClone || clickedplus)) return;

    // run only once per clone/click session
    if (ranCloneValidationRef.current) return;
    ranCloneValidationRef.current = true;

    values?.data?.forEach(async (item, index) => {
      if (index < values.data.length - 1) {
        console.log("kkkkkkkkkkkkkkkkkkkkkkkkkkkkkkkk", item);
        try {
          // Check stock availability first
          const stockApiUrl = `${url}/v1/inventory/stock/sales/items?item_id=${
            item.item_id
          }&item_quantity=${item.quantity}&base_quantity=${parseInt(
            item.base_quantity
          )}&cmr_id=${values?.cmr_id}`;
          const stockApiResponse =
            isClone || clickedplus ? await api.get(stockApiUrl) : {};

          if (
            stockApiResponse?.data?.code === 200 &&
            stockApiResponse?.data?.data?.itemDetails?.length > 0
          ) {
            // Available quantity is sufficient, proceed with handleQuantityChange
            const event = {
              target: {
                value: item.quantity,
              },
            };
            handleQuantityChange(
              event,
              index,
              item.base_quantity,
              item.item_uom_id,
              item.item_uom
            );
          } else {
            // Available quantity is insufficient, don't add batches
            console.log(`Insufficient stock for item ${item.item_name}`);

            // Update the item without batches
            const updatedData = values.data.map((row, rowIndex) =>
              rowIndex === index
                ? {
                    ...row,
                    quantity: item.quantity,
                    item_discount_amount: 0,
                    item_tax_amount: 0,
                    item_discount_percentage: 0,
                    item_gst: 0,
                    item_sgst: 0,
                    item_cgst: 0,
                    item_igst: 0,
                    item_total_amount: 0,
                    item_total_tax_percentage: 0,
                    item_batches: [], // Empty batches array
                    instock: false, // Mark as out of stock
                  }
                : row
            );
            setFieldValue("data", updatedData);

            // Show error message
            // errorToast(
            //   `Product ${item.item_name} with quantity ${item.item_to_be_delivered} is not available`
            // );
          }
        } catch (error) {
          console.log("Error checking stock availability:", error);

          // Handle error case - don't add batches
          const updatedData = values.data.map((row, rowIndex) =>
            rowIndex === index
              ? {
                  ...row,
                  quantity: item.quantity,
                  item_discount_amount: 0,
                  item_tax_amount: 0,
                  item_discount_percentage: 0,
                  item_gst: 0,
                  item_sgst: 0,
                  item_cgst: 0,
                  item_igst: 0,
                  item_total_amount: 0,
                  item_total_tax_percentage: 0,
                  item_batches: [], // Empty batches array
                  instock: false, // Mark as out of stock
                }
              : row
          );
          setFieldValue("data", updatedData);

          // Show available quantity from error response if available
          const availableQty =
            error?.response?.data?.data?.itemDetails?.item_sellable_quantity;
          if (availableQty !== undefined) {
            errorToast(
              `${item.item_name} available quantity is ${parseInt(availableQty)}`
            );
          } else {
            errorToast(`Error checking availability for ${item.item_name}`);
          }
        }
      }
    });

    // ✅ REMOVED: the stray always-running block that was updating every row
  }, [isClone, clickedplus, isNotViewOnly]);

  return (
    <>
      <LoadingOverlay isLoading={loading} />
      <div
        style={{
          maxHeight: `calc(100% - 8.5rem)`, // Limit the container height
          height: "auto", // Let it grow naturally to fit its content
        }}
        className={`border border-[var(--create-table-main-border)] border-1 border-radius p-3`}
      >
        <div
          style={{
            maxHeight: `100%`,
            minHeight: `5rem`,
          }}
          className={`tab-container border-radius ${
            disabled ? "mt-[1rem]" : ""
          }`}
        >
          <table className="w-full border-collapse mt-0">
            <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
              <tr className="relative h-[50px]">
                {heading
                  ?.filter((heading) => heading?.enabled !== false)
                  ?.map((heading, index) => (
                    <th
                      style={{ minWidth: `${heading?.minWidth}px` }}
                      key={index}
                      className={`px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                    >
                      {heading?.value === "clear_all" ? (
                        <div
                          style={{
                            display: "flex",
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                ? "center"
                                : "flex-start",
                            width: "100%", // Ensure the div takes full width of the th
                          }}
                        >
                          {!disabled && values?.data?.length > 1 && (
                            <AddButton
                              type="button"
                              onclkFn={() => {
                                if (values?.data?.length > 0) {
                                  removeRow(0, "all");
                                }
                              }}
                              prefixIcon={false}
                              text={"Clear All"}
                              className="flex items-center px-[10px] py-[10px] h-[20px] whitespace-nowrap border-radius gap-[8px]
                 bg-[var(--create-table-clearAll-bg)] 
                 cursor-pointer 
                 text-[var(--create-table-clearAll-color)] 
                 text-[length:var(--create-table-clearAll-fs)] 
                 font-[var(--create-table-clearAll-fw)] 
                 border-2 border-[var(--create-table-clearAll-border)] 
                 hover:bg-[var(--create-table-clearAll-bg)]"
                            />
                          )}
                        </div>
                      ) : heading?.childrenHeading?.length > 0 ? (
                        <div className="flex gap-3">
                          {heading?.childrenHeading?.map(
                            (childHeading, childIndex) => (
                              <div
                                style={{
                                  minWidth: `90px`,
                                  width: `${childHeading?.minWidth}px`,
                                  textAlign: childHeading?.alignment, // Keep textAlign for normal text cells
                                }}
                                className="bg-[var(--create-table-batch-con-bg)] px-3 py-1 text-[var(--create-table-batch-con-fg)] 
                              text-[length:var(--create-table-batch-con-fs)] 
                              font-[var(---create-table-batch-con-fw)] rounded-[8px]"
                              >
                                {childHeading?.label}
                              </div>
                            )
                          )}
                        </div>
                      ) : (
                        <div
                          className="flex items-center gap-2 w-full"
                          style={{
                            justifyContent:
                              heading?.alignment === "right"
                                ? "flex-end"
                                : heading?.alignment === "center"
                                ? "center"
                                : "flex-start",
                          }}
                        >
                          {heading?.label}
                        </div>
                      )}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {values?.data?.map((rowData, rowIndex) => (
                <tr
                  className={`  bg-[var(--create-table-row-bg)]   h-[50px] `}
                  key={rowIndex}
                >
                  {heading
                    ?.filter((heading) => heading?.enabled !== false)
                    ?.map((heading, index) => {
                      return (
                        <td
                          style={{
                            minWidth: `${heading?.minWidth}px`,
                            textAlign: heading?.alignment, // Keep textAlign for normal text cells
                          }}
                          key={index}
                          className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] text-[var(--create-table-row-fg-color)] whitespace-nowrap cursor-pointer"
                        >
                          {heading.value === "item_name" ||
                          heading.value === "item_code" ||
                          heading.value === "item_generic_name" ? (
                            <div title={rowData[heading.value]}>
                              <SearchAddFeild
                                menuWidth="35rem"
                                searchRef={
                                  heading.value === "item_name" ? searchRef : {}
                                }
                                isDisabled={
                                  values?.data?.length - 1 !== rowIndex ||
                                  disabled
                                    ? true
                                    : false
                                }
                                errorClass="hidden"
                                isRequired={false}
                                value={{
                                  label: rowData[heading.value],
                                  value: "",
                                }}
                                name={`data[${rowIndex}].${heading.value}`}
                                field={heading.value}
                                isLabelReq={false}
                                defaultSelectClass=""
                                placeholder=""
                                fetchData={fetchData}
                                onChange={async (selectedOption) => {
                                  const filteredData = localData
                                    ?.filter(
                                      (item) =>
                                        item?.item_id === selectedOption?.value
                                    )
                                    .map((item) => ({
                                      sl_no: 1,
                                      item_code: item.item_code,
                                      item_generic_name:
                                        item?.item_generic_name,
                                      item_name: item.item_name,
                                      item_hsn: item?.item_hsn,
                                      item_manufacturer_name:
                                        item?.item_manufacturer_name,
                                      item_uom:
                                        item.item_sales_uom_name === null
                                          ? ""
                                          : item.item_sales_uom_name,
                                      item_to_be_delivered: 0,
                                      quantity: 0,
                                      item_free_quantity: 0,
                                      item_batches: [],
                                      item_discount_amount: 0,
                                      item_total_tax_percentage: 0,
                                      item_tax_amount: 0,
                                      item_total_amount: 0,
                                      item_id: item?.item_id,
                                      instock: true,
                                      item_uom_id:
                                        item?.item_sales_uom_name_id ?? "",
                                      uom_dropdown: [],
                                      item_manufacturer_id:
                                        item.item_manufacturer,
                                      base_quantity: 0,
                                      uom_group_id: item?.item_uom || "",
                                    }));

                                  dispatch(
                                    salesProductDetailsAction(
                                      {
                                        item_id: filteredData?.[0]?.item_id,
                                        item_uom:
                                          filteredData?.[0]?.uom_group_id,
                                      },
                                      (data) => {
                                        onSuccessDetails(
                                          data,
                                          rowIndex,
                                          ...filteredData
                                        );
                                      },
                                      onErrorDetails
                                    )
                                  );
                                }}
                              />
                            </div>
                          ) : heading.value === "quantity" ? (
                            <div>
                              <Field name={`data[${rowIndex}].quantity`}>
                                {({ field }) => (
                                  <input
                                    min={0}
                                    ref={inputRefs}
                                    {...field}
                                    type="number"
                                    step="1"
                                    placeholder=""
                                    readOnly={
                                      rowIndex === values.data.length - 1 ||
                                      hasDuplicateItemId(
                                        rowData.item_id,
                                        rowIndex
                                      ) ||
                                      disabled ||
                                      !rowData?.item_uom_id ||
                                      qtyDis
                                    }
                                    onKeyDown={(event) => {
                                      if (
                                        event.key === "-" ||
                                        event.key === "e" ||
                                        event.key === "."
                                      ) {
                                        event.preventDefault();
                                      }
                                      if (
                                        event.key === "Enter"
                                      ) {
                                        // event?.preventDefault();
                                        if (searchRef && searchRef.current) {
                                          setTimeout(() => {
                                            searchRef.current.focus();
                                          }, 0);
                                        }
                                      }
                                    }}
                                    onBlur={(event) => {
                                      if (
                                        values?.data?.length - 1 === rowIndex ||
                                        hasDuplicateItemId(
                                          rowData.item_id,
                                          rowIndex
                                        ) ||
                                        disabled ||
                                        !rowData?.item_uom_id ||
                                        qtyDis
                                      ) {
                                        event?.preventDefault();
                                      } else {
                                        handleQuantityChange(
                                          event,
                                          rowIndex,
                                          rowData?.base_quantity,
                                          rowData?.item_uom_id,
                                          rowData?.item_uom
                                        );
                                      }
                                    }}
                                    className="focus-within:ring-2  px-2 w-full py-3 rounded focus-within:outline-none focus-within:shadow-[0px_0px_0px_4px_#EBF2FF input-field-no-spin-buttons min-w-[4rem]"
                                  />
                                )}
                              </Field>
                            </div>
                          ) : heading.value === "sl_no" ? (
                            <div>
                              <label
                                htmlFor={rowIndex}
                                className="block cursor-pointer select-none rounded-xl p-3 text-center hover:bg-slate-100 peer-checked:bg-blue-100 peer-checked:font-bold peer-checked:outline-none peer-checked:ring-2 peer-checked:ring-blue-500"
                              >
                                {rowIndex + 1}
                              </label>
                            </div>
                          ) : heading.value === "item_batches" ? (
                            <div className="py-1">
                              {Array.isArray(rowData.item_batches) &&
                                rowData.item_batches.map((batch, index) => (
                                  <div
                                    onClick={() => addBatchFn(rowData?.item_id)}
                                    className="flex items-center gap-3 mt-[0.5rem]"
                                  >
                                    {heading?.childrenHeading
                                      ?.filter(
                                        (heading) => heading?.enabled !== false
                                      )
                                      ?.map((heading, index) => (
                                        <div
                                          style={{
                                            minWidth: `90px`,
                                            width: `${heading?.minWidth}px`,
                                            textAlign: heading?.alignment,
                                          }}
                                          className="bg-[var(--create-table-batch-con-bg)] px-3 py-1 text-[var(--create-table-batch-con-fg)] 
                                      text-[length:var(--create-table-batch-con-fs)] 
                                      font-[var(---create-table-batch-con-fw)] rounded-[8px]"
                                        >
                                          {batch[heading.value] || "-"}
                                        </div>
                                      ))}
                                  </div>
                                ))}
                            </div>
                          ) : heading.value === "item_discount_amount" ? (
                            <>
                              <div>
                                <input
                                  style={{
                                    textAlign: "right",
                                  }}
                                  readOnly={
                                    values?.data?.length - 1 === rowIndex
                                      ? true
                                      : true
                                  }
                                  type="text"
                                  name={`data[${rowIndex}].item_discount_amount`}
                                  value={
                                    values.data[rowIndex].item_discount_amount <
                                    0
                                      ? 0
                                      : values.data[rowIndex]
                                          .item_discount_amount
                                  }
                                  className="border-0 focus_outline__none w-full "
                                />
                              </div>
                            </>
                          ) : heading.value === "item_uom" ? (
                            <>
                              <SelectField
                                style={customStyles}
                                defaultInputClass="min-h-[42px] rounded-[8px]  text-[var(--create-table-row-fg-color)] text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)] input-field-no-spin-buttons placeholder:text-[var(--create-table-row-placeholder-color)] placeholder:text-[length:var(--create-table-batch-con-fs)] placeholder:font-[var(--create-table-row-font-weight)]  "
                                inputBorder=""
                                general_color={false}
                                handleSelected={(sel) => {
                                  console.log(sel, "dffsfsdfsdfdsffdfsdfs");
                                  setFieldValue(
                                    `data[${rowIndex}].item_uom_id`,
                                    sel?.item_uom_id
                                  );
                                  setFieldValue(
                                    `data[${rowIndex}].item_uom`,
                                    sel?.label
                                  );
                                  setFieldValue(
                                    `data[${rowIndex}].base_quantity`,
                                    parseInt(sel?.base_quantity)
                                  );
                                  if (parseInt(rowData?.quantity) > 0) {
                                    handleQuantityChange(
                                      {
                                        target: {
                                          value: rowData?.quantity,
                                        },
                                      },
                                      rowIndex,
                                      sel?.base_quantity,
                                      sel?.item_uom_id,
                                      sel?.label
                                    );
                                  }
                                }}
                                borderclass=""
                                defaultSelectClass="border-0"
                                selectClass="w-full"
                                defaultValue={
                                  values.data[rowIndex]?.item_uom
                                    ? {
                                        label:
                                          values.data[rowIndex]?.item_uom ?? "",
                                      }
                                    : null
                                }
                                isDisabled={disabled}
                                errMsgContainerClass="hidden"
                                id={`data[${rowIndex}].item_uom`}
                                isContainer={false}
                                options={values.data[rowIndex]?.uom_dropdown}
                                name={`data[${rowIndex}].item_uom`}
                                placeholder={"Select UOM"}
                              />
                            </>
                          ) : heading.value === "item_free_quantity" &&
                            rowData.item_batches?.length > 0 ? (
                            rowData?.item_batches?.reduce(
                              (sum, batch) =>
                                sum +
                                (parseInt(batch.item_batch_free_quantity, 10) ||
                                  0),
                              0
                            )
                          ) : heading.value === "clear_all" ? (
                            <button
                              type="button"
                              tabIndex={-1}
                              aria-hidden="true"
                              onClick={() => {
                                removeRow(rowIndex, "");
                              }}
                              style={{
                                display: "flex",
                                justifyContent:
                                  heading?.alignment === "right"
                                    ? "flex-end"
                                    : heading?.alignment === "center"
                                    ? "center"
                                    : "flex-start",
                                width: "100%",
                              }}
                            >
                              {!disabled &&
                                rowIndex !== values?.data?.length - 1 && (
                                  <DeleteIcon className="cursor-pointer text-red-500" />
                                )}
                            </button>
                          ) : (
                            rowData[heading.value]
                          )}
                        </td>
                      );
                    })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SalesItemsSection;

const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    fontFamily: "Inter,sans-serif ",
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
    borderRadius: "10px",
    width: "100%",
    backgroundColor: state.isDisabled ? "inherit" : base.backgroundColor,
    borderColor: state.isFocused ? "transparent" : "transparent",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
    height: "100%",
  }),
  option: (provided, state) => {
    const defaultBackgroundColor = "white";
    const focusedBackgroundColor = "#0000002E";
    const selectedBackgroundColor = "#e5ecffb2";

    return {
      ...provided,
      ...(state.data.color ? { color: state.data.color } : { color: "black" }),
      backgroundColor: state.isSelected
        ? selectedBackgroundColor
        : state.isFocused
        ? focusedBackgroundColor
        : defaultBackgroundColor,
      fontSize: "14px",
      zIndex: "999",
      borderBottom: "1px solid #F5F5F5",
      fontFamily: "Inter, sans-serif",
      "&:hover": {
        backgroundColor: state.isFocused
          ? focusedBackgroundColor
          : focusedBackgroundColor,
      },
    };
  },
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "var(--placeholder-color)",
      fontFamily: "Inter,sans-serif",
      fontWeight: "400",
      opacity: "1",
      whiteSpace: "nowrap",
    };
  },
  multiValue: (base) => ({
    ...base,
    fontFamily: "Inter,sans-serif ",
    backgroundColor: "#E5ECFF",
    gap: "5px",
    padding: "0px 6px",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--create-table-row-fg-color)",
    fontFamily: "Inter,sans-serif",
    fontWeight: "var(--create-table-row-font-weight)",
    fontSize: "var(--create-table-row-font-size)",
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    ...(state.selectProps.menuIsOpen
      ? {
          transform: "rotate(180deg)",
        }
      : {}),
  }),
};
